import React from "react";

import {BRAND_NAME} from "../../app/constants/company";
import {rpCommonUrl} from "../../app/read_rp_environment_variables";

interface IProps {
    name: string | undefined;
    description: string | undefined;
    pathname: string | undefined;
    authorImageUrl: string | undefined;
}

export const SchemaArticleAuthorDetail = (props: IProps) => {
    const {name, description, pathname, authorImageUrl} = props;

    const json = {
        "@context": "https://schema.org/",
        "@type": "Person",
        name,
        image: {
            "@type": "ImageObject",
            url: `${authorImageUrl}`
        },
        url: `${rpCommonUrl}${pathname}`,
        jobTitle: `Autor ${BRAND_NAME}`,
        description,
        worksFor: {
            "@type": "Organization",
            name: `portal ${BRAND_NAME}`
        }
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import React from "react";

import {BRAND_NAME} from "../../app/constants/company";
import {rpCommonUrl} from "../../app/read_rp_environment_variables";

interface IProps {
    name: string | undefined;
    description: string | undefined;
    pathname: string | undefined;
    authorImageUrl: string | undefined;
}

export const SchemaArticleAuthorDetail = (props: IProps) => {
    const {name, description, pathname, authorImageUrl} = props;

    const json = {
        "@context": "https://schema.org/",
        "@type": "Person",
        name,
        image: {
            "@type": "ImageObject",
            url: `${authorImageUrl}`
        },
        url: `${rpCommonUrl}${pathname}`,
        jobTitle: `Autor ${BRAND_NAME}`,
        description,
        worksFor: {
            "@type": "Organization",
            name: `portal ${BRAND_NAME}`
        }
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
